import { getTranslatedData } from '@app/helpers/getTranslatedData'
import { User, Account } from '@app/models'

import { trackGTMEventBase } from './trackGTMEvent'

export const initGTM = (user: User, account: Account) => {
  const obj = {
    email: user.email,
    fullName: user.fullName,
    userId: user.id,
    accountId: account.id,
    accountName: getTranslatedData(account.name),
    accountType: account.type == 'Professional' ? 'Office' : account.type,
    accountCountry:
      account.regionalSettings && account.regionalSettings.countryISO,
    accountEmail: account.email,
    importId: user.importId,
    hasGlobalAgent: account.isGlobalAgent == true,
    registrationDate: user.registrationDate,
    registrationType: user.registrationType,
    socialNetworks: (user.socialNetworks || []).map((x) => x.id),
    event: 'initApp',
  }
  trackGTMEventBase(obj)
}
